import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const CircleIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 6, height = 6, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        ref={ref}
        viewBox="0 0 6 6"
        fill="none"
        {...props}
      >
        <circle cx="3" cy="3" r="3" fill="#30D158" />
      </svg>
    );
  },
);
